import { PreviewContentType } from './_shared/PreviewContentType';
import Image from 'components/Image';

export const choosePreviewContentType = (
  type?: string,
  thumbnail?: string,
  progress?: number
): PreviewContentType => {
  if (!type) {
    return 'image'; // this is mostly used as a generic loader when we don't know the type yet
  }

  if (type) {
    if (type === 'application/pdf') {
      return 'pdf';
    }
    if (type === 'application/mp4') {
      return 'video';
    }
    if (type.startsWith('image') && Image.isSupportedType(type)) {
      return 'image';
    }
    if (type.startsWith('video')) {
      return 'video';
    }
    if (type.startsWith('audio')) {
      return 'audio';
    }
  }
  return 'file';
};
